<extra-information [tipContent]="'financial-obligations.payment-account-overdraft.tip' | apContent"></extra-information>

<next-button (click)="nextQuestion()"></next-button>
